export const initialValues = {
  district_id: null,
  name: "",
  is_active: 1,
};
